// Turn a failed request into a message that is always safe to render.
//
// FastAPI's `detail` changes shape depending on what rejected the request:
// an HTTPException gives a string, but request validation (422) gives an array
// of { loc, msg, type } objects, and a few endpoints raise a structured object.
// Toasts and error banners render whatever they're handed as a React child, so
// passing that array straight in throws mid-render — and because <Toaster> sits
// outside the ErrorBoundary, the whole app unmounts to a blank white screen.
// That is how a single bad field on Full Ledger's Save used to blank the page.

export function apiErrorMessage(err: any, fallback: string): string {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail.trim() || fallback;

  if (Array.isArray(detail)) {
    const messages = detail
      .map((d: any) => {
        if (typeof d === 'string') return d;
        if (typeof d?.msg !== 'string') return '';
        // loc is ["body", "<field>"] — name the field so the message says
        // which input was rejected, not just that one was.
        const field = Array.isArray(d.loc) ? d.loc[d.loc.length - 1] : '';
        return typeof field === 'string' && field !== 'body' ? `${field}: ${d.msg}` : d.msg;
      })
      .filter(Boolean);
    if (messages.length) return messages.join('; ');
  }

  if (typeof detail?.message === 'string' && detail.message) return detail.message;
  return fallback;
}
